import moment from 'moment-timezone'
import { isEmpty } from './appUtils'

export const promoValidate = promos => {
    const hawaiiTimeZone = moment().tz('Pacific/Honolulu')
    const hawaiiDate = hawaiiTimeZone.format('MM/DD/YYYY')
    const hawaiiTime = hawaiiTimeZone.format('HH:mm')
    const dayShortName = hawaiiTimeZone.format('ddd')

    const activePromos = promos.filter(promo => {
        // Validate date range
        const isWithinRange = moment(hawaiiDate, 'MM/DD/YYYY').isBetween(
            moment(promo?.start_date, 'MM/DD/YYYY'),
            moment(promo?.expiration_date, 'MM/DD/YYYY'),
            undefined,
            '[]'
        )

        // Validate time range
        const isWithinTime = isEmpty(promo?.condition_betweenHours)
            ? true
            : moment(hawaiiTime, 'HH:mm').isBetween(
                  moment(promo?.condition_betweenHours?.from, 'HH:mm'),
                  moment(promo?.condition_betweenHours?.to, 'HH:mm'),
                  undefined,
                  '[]'
              )

        // Validate date recurrence
        const isValidDateRecurrence = validateDateRecurrence(
            promo?.condition_dateRecurrence,
            hawaiiDate,
            dayShortName
        )

        return isWithinRange && isWithinTime && isValidDateRecurrence
    })

    return activePromos
}

const validateDateRecurrence = (condition_dateRecurrence, hawaiiDate, dayShortName) => {
    const months = condition_dateRecurrence?.month
    const days = condition_dateRecurrence?.day
    const weekDays = condition_dateRecurrence?.weekDay
    let monthCheck = false
    let weekDayCheck = false
    let dayCheck = false
    if (months?.length) {
        months.map(month => {
            if (month == hawaiiDate?.split('/')[0]) {
                monthCheck = true
            }
        })
        if (!monthCheck) return false
    }
    if (weekDays?.length) {
        weekDays.map(day => {
            if (day.toLowerCase() == dayShortName.toLowerCase()) {
                weekDayCheck = true
            }
        })
        if (!weekDayCheck) return false
    }
    if (days?.length) {
        days.map(day => {
            if (day == hawaiiDate?.split('/')[1]) {
                dayCheck = true
            }
        })
        if (!dayCheck) return false
    }

    return true
}
